type ChatTabContentProps = {
    isSelected: boolean;
    children: React.ReactNode;
};

const ChatTabContent: React.FC<ChatTabContentProps> = ({ isSelected, children }) => {
    return (
        <div
            
            className={`${isSelected ? "flex" : "flex"} w-full h-full`}
        >
            {children}
        </div>
    );
};

export default ChatTabContent;
